export interface GenerateOTPDto
{
    getMsisdn(): string;
}

export class GenerateOTPDtoImpl implements GenerateOTPDto
{
    private msisdn: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto.tsx